import React from 'react';
export function SubscriberIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 22H7a2 2 0 01-2-2v-3a5.01 5.01 0 013.258-4.688A5 5 0 017 9V7a5 5 0 1110 0v2a4.992 4.992 0 01-1.255 3.314A5.008 5.008 0 0119 17v3a2 2 0 01-2 2zM12 4a2.994 2.994 0 00-3 3v2a3 3 0 001.5 2.593 1 1 0 01.5.867V13a1 1 0 01-1 1 3 3 0 00-3 3v3h10v-3a3 3 0 00-3-3 1 1 0 01-1-1v-.54a1 1 0 01.507-.87c.23-.134.44-.295.63-.481A3 3 0 0015 9V7a2.994 2.994 0 00-3-3z"
  }));
}